export default __webpack_public_path__ + "static/media/CollectionBack.a817fb9d.svg";